import {
    apiRequest,
    employeeStatusList,
    employeeStatusActive,
    employeeStatusInactive
} from "../../../../../services/adapters/master/employeeStatusService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", employeeStatusList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", employeeStatusInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", employeeStatusActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository